import React, { useState } from 'react';
import PropTypes from 'prop-types';
import IconUpload from '../../icons/IconUpload';
import styles from './styles.scoped.css';

function ImageUploader({
  className,
  input,
  inputProps,
  meta: { touched, error },
  // hideLabel = false
}) {
  const [errorSize, setErrorSize] = useState('');
  const { onChange, value = { name: '', url: '' } } = input;
  const isError = touched && error || errorSize ? 'isError' : '';
  const classes = ['root', className, isError].filter(Boolean).join(' ');
  const fileMaxSize = 2 * 1024 ** 2;

  const handleChange = (event) => {
    const file = event.target.files[0];
    const url = URL.createObjectURL(file);
    const name = file.name;

    if(file.size > fileMaxSize){
      setErrorSize('Tidak dapat mengunggah gambar, ukuran gambar melebihi 2MB');
      onChange({ name: '', url: '' });
      return;
    }

    setErrorSize('');
    onChange({ name, url });
  };

  return (
    <div className={classes}>
      {inputProps.label && <label>{inputProps.label}</label>}
      <div className={styles.content}>
        <div>
          {value.url ? (
            <div className={styles.exist}>
              <img alt={value.name} src={value.url} />
              <p>{value.name}</p>
            </div>
          ) : (
            <div className={styles.empty}>
              <IconUpload />
              <span>{inputProps.label}</span>
            </div>
          )}
          <input
            {...inputProps}
            accept="image/png, image/jpeg"
            className={styles.input}
            // onBlur={onBlur}
            onChange={handleChange}
            type="file"
          />
        </div>
        <p>
          Gambar maksimal 2 MB dengan format PNG atau JPG untuk melengkapi
          informasi Anda.
        </p>
      </div>
      {errorSize && <span className={styles.error}>{errorSize}</span>}
      {touched && error && <span className={styles.error}>{error}</span>}
    </div>
  );
}

ImageUploader.propTypes = {
  className: PropTypes.string,
  hideLabel: PropTypes.bool,
  input: PropTypes.object,
  inputProps: PropTypes.object,
  meta: PropTypes.object,
};

export default ImageUploader;
